import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { PreLoginBaseComponent } from './pre-login-base/pre-login-base.component';
import {PreLoginRoutingModule} from './pre-login-routing.module';
import { LandingComponent } from './landing/landing.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { SplashComponent } from './splash/splash.component';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
import { PreLoginHeaderComponent } from './pre-login-header/pre-login-header.component';
import { SignUpBasicInformationComponent } from './sign-up-basic-information/sign-up-basic-information.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { LandingTronComponent } from './landing-tron/landing-tron.component';
import { LandingNonTronComponent } from './landing-non-tron/landing-non-tron.component';

@NgModule({
  declarations: [PreLoginBaseComponent, LandingComponent, LoginComponent, SignupComponent, SplashComponent, ConfirmationPopupComponent, ResetPasswordComponent, PreLoginHeaderComponent, SignUpBasicInformationComponent, UpdatePasswordComponent, LandingTronComponent, LandingNonTronComponent],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    PreLoginRoutingModule,
    NgbModule
  ],
  exports: [
    PreLoginBaseComponent
  ]
})
export class PreLoginModule { }
